/**
 * Gets the names of all functions from a class's prototype
 * @param target
 * @returns {PropertyKey[]}
 */
export function functions (target) {
  return Reflect
    .ownKeys(target)
    .filter(key => key !== 'constructor');
}
